import React from 'react';
import { Redirect } from 'react-router';

const HTORedirect = () => (
    <Redirect to="/HTO" />
);

export default HTORedirect;
